import { UseParsers } from '../interfaces';

export const useParsers: () => UseParsers = (): UseParsers => {
  const parsePrice = (price: number): string => {
    return Intl.NumberFormat('en', { 
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(price).replace('.00', '').replace(',', ' ').replace('.',',');
  };

  return { parsePrice };
};
